import { useState, useEffect } from 'react'
import {
  add,
  eachDayOfInterval,
  endOfMonth,
  endOfWeek,
  format,
  getDay,
  isEqual,
  isSameDay,
  isSameMonth,
  parse,
  parseISO,
  startOfMonth,
  startOfToday,
  startOfWeek
} from 'date-fns'
import { auth, db } from '../firebase'
import {
  collection,
  getDocs,
  query,
  where,
  orderBy,
  limit,
  QuerySnapshot,
  DocumentData
} from 'firebase/firestore'
import { BsArrowLeftCircleFill, BsArrowRightCircleFill } from 'react-icons/bs'
import Layout from '../components/layout'
import MainTitle from '../components/main_title'
import { getIconBySentiment } from '../components/icons'
import { User } from 'firebase/auth'
import { IJournal } from '../types/journal'

// const meetings = [
//   {
//     id: 1,
//     name: 'Leslie Alexander',
//     imageUrl:
//       'https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
//     startDatetime: '2022-05-11T13:00',
//     endDatetime: '2022-05-11T14:30',
//   },
//   {
//     id: 2,
//     name: 'Michael Foster',
//     imageUrl:
//       'https://images.unsplash.com/photo-1519244703995-f4e0f30006d5?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
//     startDatetime: '2022-05-20T09:00',
//     endDatetime: '2022-05-20T11:30',
//   },
// ]

function classNames(...classes: any[]) {
  return classes.filter(Boolean).join(' ')
}

export default function Calendar() {
  const user = auth.currentUser as User
  const [journals, setJournals] = useState<IJournal[]>([])

  let today = startOfToday()
  let [selectedDay, setSelectedDay] = useState(today)
  let [currentMonth, setCurrentMonth] = useState(format(today, 'MMM-yyyy'))
  let firstDayOfCurrentMonth = startOfMonth(
    parse(currentMonth, 'MMM-yyyy', new Date())
  )
  let days = eachDayOfInterval({
    start: startOfWeek(firstDayOfCurrentMonth),
    end: endOfWeek(endOfMonth(firstDayOfCurrentMonth))
  }).map((date) => ({
    date
  }))

  function next() {
    let firstDayOfNextMonth = add(firstDayOfCurrentMonth, { months: 1 })
    setCurrentMonth(format(firstDayOfNextMonth, 'MMM-yyyy'))
  }

  function previous() {
    let firstDayOfNextMonth = add(firstDayOfCurrentMonth, { months: -1 })
    setCurrentMonth(format(firstDayOfNextMonth, 'MMM-yyyy'))
  }

  useEffect(() => {
    const fetchListings = async () => {
      try {
        // Get reference
        const journalRef = collection(db, 'journals')

        // Create a query
        const q = query(
          journalRef,
          where('uid', '==', user.uid),
          orderBy('date', 'desc'),
          limit(10)
        )

        // Execute query
        const querySnap: QuerySnapshot<DocumentData> = await getDocs(q)
        const formatted = convert(querySnap)
        console.log(`formatted=${JSON.stringify(formatted)}`)
        console.log(formatted[0].date)

        console.log(parseISO(formatted[0].date.toString()))

        setJournals(formatted)
      } catch (err) {
        console.error(`Could not fetch listings: ${err}`)
      }
    }

    // console.log(`days=${JSON.stringify(days)}`)

    fetchListings()
  }, [user.uid])

  function convert(querySnap: QuerySnapshot<DocumentData>) {
    const ret: IJournal[] = []

    querySnap.forEach((doc) => {
      const docSnap = doc.data()
      const row = {
        id: docSnap.id,
        date: docSnap.date.toDate().toISOString(),
        sentiment: docSnap.sentiment
      }
      return ret.push(row)
    })

    return ret
  }

  // if (journals.length !== 0) {
  //   console.log(`journals=${JSON.stringify(journals)}`)
  //   const foo = journals[0]
  //   debugger
  // }

  return (
    <Layout>
      <MainTitle title="Calendar" />
      <div className="mx-auto max-w-md rounded-2xl bg-primary md:max-w-4xl">
        {/* <div className="md:grid md:grid-cols-2 md:divide-x md:divide-gray-200"> */}
        <div className="flex items-center justify-between rounded-2xl bg-tertiary p-6">
          <h2 className="text-2xl text-white">
            {format(firstDayOfCurrentMonth, 'MMMM yyyy')}
          </h2>
          <div>
            <button
              onClick={previous}
              type="button"
              className="text-white hover:text-primary"
            >
              <BsArrowLeftCircleFill size={28} />
            </button>
            &nbsp;&nbsp;
            <button
              onClick={next}
              type="button"
              className="text-white hover:text-primary"
            >
              <BsArrowRightCircleFill size={28} />
            </button>
          </div>
        </div>
        <div className="p-4">
          <div className="rounded-2xl bg-white">
            <div className="grid grid-cols-7 pt-4 text-center text-xs leading-6 text-gray-500">
              <div>S</div>
              <div>M</div>
              <div>T</div>
              <div>W</div>
              <div>T</div>
              <div>F</div>
              <div>S</div>
            </div>
            <div className="mt-2 grid grid-cols-7 text-sm">
              {days.map((day, dayIdx) => (
                <div
                  key={day.date.toString()}
                  className={classNames(
                    dayIdx > 6 && 'border-t border-gray-200',
                    dayIdx === 0 && colStartClasses[getDay(day.date)],
                    'pb-2 pt-4'
                  )}
                >
                  <button
                    type="button"
                    onClick={() => setSelectedDay(day.date)}
                    className={classNames(
                      isEqual(day.date, selectedDay) && 'text-white',
                      !isEqual(day.date, selectedDay) &&
                        isEqual(day.date, today) &&
                        'text-red-500',
                      !isEqual(day.date, firstDayOfCurrentMonth) &&
                        !isEqual(day.date, today) &&
                        isSameMonth(
                          day.date,
                          startOfMonth(firstDayOfCurrentMonth)
                        ) &&
                        'text-gray-900',
                      !isEqual(day.date, firstDayOfCurrentMonth) &&
                        !isEqual(day.date, today) &&
                        !isSameMonth(
                          day.date,
                          startOfMonth(firstDayOfCurrentMonth)
                        ) &&
                        'text-gray-400',
                      isEqual(day.date, selectedDay) &&
                        isEqual(day.date, today) &&
                        'bg-red-500',
                      isEqual(day.date, selectedDay) &&
                        !isEqual(day.date, today) &&
                        'bg-gray-900',
                      !isEqual(day.date, selectedDay) && 'hover:bg-gray-200',
                      (isEqual(day.date, selectedDay) ||
                        isEqual(day.date, today)) &&
                        'font-semibold',
                      'mx-auto flex h-8 w-8 items-center justify-center rounded-full'
                    )}
                  >
                    <time dateTime={day.date.toString()}>
                      {format(day.date, 'd')}
                    </time>
                  </button>
                  <div className="mx-auto mt-1 h-6 w-6">
                    {journals.some((journal) =>
                      isSameDay(parseISO(journal.date.toString()), day.date)
                    ) && (
                      <div>
                        {getIconBySentiment(
                          journals.filter((journal) =>
                            isSameDay(
                              parseISO(journal.date.toString()),
                              day.date
                            )
                          )[0].sentiment,
                          30
                        )}
                      </div>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </Layout>
  )
}

// function Meeting({ meeting }) {
//   let startDatetime = parseISO(meeting.startDatetime)
//   let endDatetime = parseISO(meeting.endDatetime)

//   return (
//     <li className="flex items-center px-4 py-2 space-x-4 group rounded-xl focus-within:bg-gray-100 hover:bg-gray-100">
//       <img
//         src={meeting.imageUrl}
//         alt=""
//         className="flex-none w-10 h-10 rounded-full"
//       />
//       <div className="flex-auto">
//         <p className="text-gray-900">{meeting.name}</p>
//         <p className="mt-0.5">
//           <time dateTime={meeting.startDatetime}>
//             {format(startDatetime, 'h:mm a')}
//           </time>{' '}
//           -{' '}
//           <time dateTime={meeting.endDatetime}>
//             {format(endDatetime, 'h:mm a')}
//           </time>
//         </p>
//       </div>
//       <Menu
//         as="div"
//         className="relative opacity-0 focus-within:opacity-100 group-hover:opacity-100"
//       >
//         <div>
//           <Menu.Button className="-m-2 flex items-center rounded-full p-1.5 text-gray-500 hover:text-gray-600">
//             <span className="sr-only">Open options</span>
//             {/* <DotsVerticalIcon className="w-6 h-6" aria-hidden="true" /> */}
//           </Menu.Button>
//         </div>
//         <Transition
//           as={Fragment}
//           enter="transition ease-out duration-100"
//           enterFrom="transform opacity-0 scale-95"
//           enterTo="transform opacity-100 scale-100"
//           leave="transition ease-in duration-75"
//           leaveFrom="transform opacity-100 scale-100"
//           leaveTo="transform opacity-0 scale-95"
//         >
//           <Menu.Items className="absolute right-0 z-10 mt-2 origin-top-right bg-white rounded-md shadow-lg w-36 ring-1 ring-black ring-opacity-5 focus:outline-none">
//             <div className="py-1">
//               <Menu.Item>
//                 {({ active }) => (
//                   <a
//                     href="#"
//                     className={classNames(
//                       active ? 'bg-gray-100 text-gray-900' : 'text-gray-700',
//                       'block px-4 py-2 text-sm'
//                     )}
//                   >
//                     Edit
//                   </a>
//                 )}
//               </Menu.Item>
//               <Menu.Item>
//                 {({ active }) => (
//                   <a
//                     href="#"
//                     className={classNames(
//                       active ? 'bg-gray-100 text-gray-900' : 'text-gray-700',
//                       'block px-4 py-2 text-sm'
//                     )}
//                   >
//                     Cancel
//                   </a>
//                 )}
//               </Menu.Item>
//             </div>
//           </Menu.Items>
//         </Transition>
//       </Menu>
//     </li>
//   )
// }

let colStartClasses = [
  '',
  'col-start-2',
  'col-start-3',
  'col-start-4',
  'col-start-5',
  'col-start-6',
  'col-start-7'
]
